import AxiosApi from "@/config/axios";

const ContractService = {};

ContractService.getResume = () => {
    return AxiosApi({
        url: `/contract/resume`,
        method: 'get',
    })
}


export default ContractService;